module.exports = __webpack_public_path__ + "static/2-113a8a219138858d0fb35b8ef372a19f.png";